var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#07266B"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.375s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#fce053"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#F23065"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.125s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#275D2B"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e76fe1264ad04bb92e7e395ef02953be.svg";
export { ForwardRef as ReactComponent };